<template>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs12 md8 lg7 class="expandableContainer">
        <v-layout row wrap>
          <v-flex xs12>
            <p>
              <b>
                {{
                  $t(
                    'configuration.cell_phone_app_settings.mobile_device_app_preview'
                  )
                }}
              </b>
            </p>
          </v-flex>
          <v-flex xs12 md4 lg5 xl7>
            <p>
              <b>
                {{
                  $t(
                    'configuration.cell_phone_app_settings.mobile_device_app_side_menu'
                  )
                }}
              </b>
            </p>
            <v-navigation-drawer permanent v-model="drawer">
              <v-list class="pa-1 grey lighten-2">
                <v-list-tile avatar>
                  <v-list-tile-avatar>
                    <img
                      v-if="user.img != '' && user.img != null"
                      :src="user.img"
                      alt="avatar"
                    />
                    <v-icon v-else>account_circle</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      user.firstName + ' ' + user.lastName
                    }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-layout class="items">
                <v-list class="pt-0" dense style="width: 100%">
                  <template v-for="item in sideItems">
                    <v-list-tile
                      :key="item.id"
                      v-if="isSectionPresent(item.catalog)"
                      @click.stop="
                        item.id == 8 ? (flags.settings = !flags.settings) : ''
                      "
                    >
                      <v-list-tile-action>
                        <div :class="item.key"></div>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ $t(item.langKey) }}
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </template>
                </v-list>
              </v-layout>
            </v-navigation-drawer>
          </v-flex>
          <v-slide-x-transition mode="out-in">
            <v-flex :key="0" xs12 md8 lg7 xl5 v-if="!flags.settings">
              <p>
                <b>
                  {{
                    $t(
                      'configuration.cell_phone_app_settings.panel.mobile_app_main_screen'
                    )
                  }}
                </b>
              </p>
              <v-container grid-list-xs>
                <v-layout row wrap justify-center>
                  <v-flex xs12>
                    <v-toolbar flat tabs>
                      <v-toolbar-side-icon @click.stop="drawer = !drawer">
                        <v-icon color="grey">account_circle</v-icon>
                      </v-toolbar-side-icon>
                      <v-toolbar-title class="text-xs-center">
                        {{ dictionary(bottomNav) }}
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <template v-slot:extension>
                        <v-tabs
                          :key="0"
                          v-model="tabs"
                          fixed-tabs
                          color="transparent"
                          grow
                          v-if="bottomNav == 'PICK_UP'"
                        >
                          <v-tabs-slider color="primary"></v-tabs-slider>
                          <v-tab :key="'family'">
                            {{
                              $t(
                                'configuration.cell_phone_app_settings.panel.family'
                              )
                            }}
                          </v-tab>
                          <v-tab
                            :key="'round'"
                            v-if="isSectionPresent('ROUND_PICK_UP')"
                          >
                            {{
                              $t(
                                'configuration.cell_phone_app_settings.panel.carpool'
                              )
                            }}
                          </v-tab>
                        </v-tabs>
                        <v-tabs
                          v-model="tabsPermissions"
                          fixed-tabs
                          color="transparent"
                          grow
                          v-else-if="bottomNav == 'PERMISSIONS'"
                        >
                          <v-tabs-slider color="primary"></v-tabs-slider>
                          <v-tab
                            v-if="
                              isSectionPresent('THIRD_QR') &&
                              isSectionPresent('CHECKOUT_AUTHORIZATION') ==
                                false
                            "
                            :key="0"
                          >
                            {{
                              $t(
                                'configuration.cell_phone_app_settings.panel.third_parties'
                              )
                            }}
                          </v-tab>
                          <v-tab
                            v-if="
                              isSectionPresent('CHECKOUT_AUTHORIZATION') &&
                              isSectionPresent('THIRD_QR') === false
                            "
                            :key="0"
                          >
                            {{
                              $t(
                                'configuration.cell_phone_app_settings.panel.authorizations'
                              )
                            }}
                          </v-tab>
                          <v-tab
                            v-if="
                              isSectionPresent('THIRD_QR') &&
                              isSectionPresent('CHECKOUT_AUTHORIZATION')
                            "
                            :key="0"
                          >
                            {{
                              $t(
                                'configuration.cell_phone_app_settings.panel.third_parties'
                              )
                            }}
                          </v-tab>
                          <v-tab
                            v-if="
                              isSectionPresent('CHECKOUT_AUTHORIZATION') &&
                              isSectionPresent('THIRD_QR')
                            "
                            :key="1"
                          >
                            {{
                              $t(
                                'configuration.cell_phone_app_settings.panel.authorizations'
                              )
                            }}
                          </v-tab>
                        </v-tabs>
                      </template>
                    </v-toolbar>
                    <v-container grid-list-xs v-if="bottomNav === 'PICK_UP'">
                      <v-tabs-items v-model="tabs">
                        <v-tab-item :key="'family'">
                          <v-container grid-list-xs>
                            <v-layout row wrap justify-center>
                              <v-flex
                                xs6
                                v-for="n in 4"
                                :key="n"
                                style="border-radius: 50%; height: 150px"
                              >
                                <v-avatar color="grey lighten-4" size="140px">
                                  <v-img
                                    :src="require('@/assets/mobil/student.png')"
                                  ></v-img>
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-tab-item>
                        <v-tab-item
                          v-if="isSectionPresent('ROUND_PICK_UP')"
                          :key="'round'"
                        >
                          <v-container grid-list-xs>
                            <v-layout row wrap justify-center>
                              <v-flex
                                xs6
                                v-for="n in 4"
                                :key="n"
                                style="border-radius: 50%; height: 150px"
                              >
                                <v-avatar color="grey lighten-4" size="140px">
                                  <v-img
                                    :src="require('@/assets/mobil/round.png')"
                                  ></v-img>
                                </v-avatar>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-container>
                    <v-container
                      grid-list-xs
                      v-if="bottomNav === 'PERMISSIONS'"
                    >
                      <v-tabs-items
                        :key="Math.random()"
                        v-model="tabsPermissions"
                      >
                        <ThirdQrList
                          v-if="
                            isSectionPresent('THIRD_QR') &&
                            isSectionPresent('CHECKOUT_AUTHORIZATION') === false
                          "
                          :tab-key="0"
                        />
                        <AuthorizationList
                          v-if="
                            isSectionPresent('CHECKOUT_AUTHORIZATION') &&
                            isSectionPresent('THIRD_QR') === false
                          "
                          :tab-key="0"
                        />
                        <ThirdQrList
                          v-if="
                            isSectionPresent('THIRD_QR') &&
                            isSectionPresent('CHECKOUT_AUTHORIZATION')
                          "
                          :tab-key="0"
                        />
                        <AuthorizationList
                          v-if="
                            isSectionPresent('CHECKOUT_AUTHORIZATION') &&
                            isSectionPresent('THIRD_QR')
                          "
                          :tab-key="1"
                        />
                      </v-tabs-items>
                    </v-container>
                    <v-container grid-list-xs v-if="bottomNav == 'NOTICE'">
                      <v-layout row wrap>
                        <v-flex xs12 mt-1 v-for="n in 4" :key="n">
                          <v-card style="border-radius: 13px">
                            <v-layout row wrap>
                              <v-flex xs3>
                                <v-img
                                  :src="
                                    require('@/assets/panel/home/SKLB-Comunidad.png')
                                  "
                                ></v-img>
                              </v-flex>
                              <v-flex xs9>
                                <b>Comunicado {{ n }}</b>
                                <p class="text-xs-left">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit.
                                </p>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-container
                      grid-list-xs
                      v-if="bottomNav == 'NOTIFICATION'"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 mt-1 v-for="n in 4" :key="n">
                          <v-card style="border-radius: 13px">
                            <v-layout row wrap>
                              <v-flex xs3>
                                <v-img
                                  :src="
                                    require('@/assets/mobil/notificationbubble.png')
                                  "
                                ></v-img>
                              </v-flex>
                              <v-flex xs9>
                                <b>Notificación {{ n }}</b>
                                <p class="text-xs-left">
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit.
                                </p>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-bottom-nav
                      :active.sync="bottomNav"
                      :value="true"
                      color="grey lighten-3"
                      class="elevation-0"
                    >
                      <v-btn
                        color="primary"
                        flat
                        :value="item.name"
                        v-for="item in bottomNavigation"
                        :key="item.id"
                      >
                        <span>{{ dictionary(item.name) }}</span>
                        <v-avatar size="30px">
                          <div :class="item.name"></div>
                          <!-- <v-img :src="require('@/assets/mobil/'+item.name+'.png')"></v-img> -->
                        </v-avatar>
                      </v-btn>
                      <v-btn color="primary" flat value="NOTIFICATION">
                        <span>
                          {{
                            $t(
                              'configuration.cell_phone_app_settings.panel.notifications'
                            )
                          }}
                        </span>
                        <v-avatar size="30px">
                          <div class="NOTIFICATION"></div>
                        </v-avatar>
                      </v-btn>
                    </v-bottom-nav>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex :key="1" xs12 md8 lg7 xl5 v-else>
              <p>
                <b>Sección de ajustes del dispositivo móvil</b>
              </p>
              <v-container grid-list-xs>
                <v-layout row wrap justify-center>
                  <v-flex xs12>
                    <v-toolbar flat tabs>
                      <v-btn
                        flat
                        @click.stop="flags.settings = !flags.settings"
                      >
                        <v-icon color="primary">chevron_left</v-icon>Salidas
                      </v-btn>
                      <v-toolbar-title class="text-xs-center"
                        >Ajustes</v-toolbar-title
                      >
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-layout class="items">
                          <v-list class="pt-0" dense style="width: 100%">
                            <template v-for="item in settingsItems">
                              <v-divider></v-divider>
                              <v-list-tile
                                :key="item.id"
                                v-if="isSectionPresent(item.catalog)"
                              >
                                <v-list-tile-action>
                                  <div :class="item.key"></div>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{
                                    item.name
                                  }}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-slide-x-transition>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 lg5 xl5>
        <v-container grid-list-xs>
          <v-layout row wrap>
            <v-flex xs12>
              <v-list subheader>
                <v-subheader>
                  {{
                    $t('configuration.cell_phone_app_settings.panel.sections')
                  }}
                  <!-- <v-tooltip right>
                    <template>
                      <v-btn fab flat small slot="activator" @click="modals.editSections = true">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar secciones</span>
                  </v-tooltip>-->
                </v-subheader>
                <template v-for="permit in sections">
                  <v-list-tile
                    v-if="
                      (permit.name === 'ACTIVATE_ACCESS_QR' &&
                        getBranch.hasAccessDevices) ||
                      permit.name !== 'ACTIVATE_ACCESS_QR'
                    "
                    avatar
                    :key="permit.id"
                  >
                    <v-list-tile-avatar>
                      <v-checkbox
                        v-if="permit.name === 'CHECKOUT_AUTHORIZATION'"
                        color="primary"
                        return-object
                        v-model="sectionForm.selected"
                        :value="permit"
                        :disabled="!isValidCheckoutAuhorizationBtn"
                      />
                      <v-checkbox
                        v-else
                        color="primary"
                        return-object
                        v-model="sectionForm.selected"
                        :value="permit"
                      />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ dictionary(permit.name) }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn
                        @click="help(permit.name)"
                        fab
                        small
                        class="helpButton elevation-0"
                        color="transparent"
                        >?</v-btn
                      >
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="
                      (permit.name === 'ACTIVATE_ACCESS_QR' &&
                        getBranch.hasAccessDevices) ||
                      permit.name !== 'ACTIVATE_ACCESS_QR'
                    "
                  ></v-divider>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <help
      v-model="modals.help"
      :title="modals.title"
      :description="modals.description"
    ></help>
    <editMobileSections
      v-model="modals.editSections"
      :profile="profile"
      :branch="branch"
      @edited="updateSections"
    ></editMobileSections>
    <loading v-model="working.w" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Creación Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
import error from '../../Dialogs/Error.vue'
import help from '../../Dialogs/Help'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import editMobileSections from '../../Modals/EditMobileSections'
import AuthorizationList from './components/authorizationList.vue'
import ThirdQrList from './components/thirdQrList.vue'
export default {
  components: {
    editMobileSections,
    help,
    loading,
    success,
    error,
    ThirdQrList,
    AuthorizationList,
  },
  props: ['branch', 'user', 'updateFlag'],
  validations: {
    sectionForm: {
      selected: {
        onlyOne() {
          return this.sectionForm.selected.length > 0 ? true : false
        },
      },
    },
  },
  data: () => ({
    drawer: false,
    tabs: null,
    tabsPermissions: null,
    bottomNav: '',
    mobileCatalogs: [],
    profile: {},
    working: {
      w: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    sectionForm: {
      selected: [],
    },
    flags: {
      settings: false,
    },
    modals: {
      editSections: false,
      help: false,
      title: '',
      description: '',
    },
    settingsItems: [
      {
        id: 1,
        key: 'students',
        name: 'Alumnos',
        catalog: 'STUDENTS',
      },
      {
        id: 2,
        key: 'rounds',
        name: 'Rondas',
        catalog: 'ROUNDS',
      },
      {
        id: 3,
        key: 'cars',
        name: 'Mis autos',
        catalog: 'CARS',
      },
      {
        id: 4,
        key: 'billing',
        name: 'Facturación',
        catalog: 'BILLING',
      },
    ],
    sideItems: [
      {
        id: 1,
        key: 'annoucement',
        name: 'Avisos',
        catalog: 'NOTICE',
        langKey:
          'configuration.cell_phone_app_settings.left_panel.school_bulletin_board',
      },
      {
        id: 2,
        key: 'events',
        name: 'Eventos',
        catalog: 'NOTICE',
        langKey: 'configuration.cell_phone_app_settings.left_panel.events',
      },
      {
        id: 3,
        key: 'reports',
        name: 'Desempeño',
        catalog: 'NOTICE',
        langKey: 'configuration.cell_phone_app_settings.left_panel.performance',
      },
      {
        id: 4,
        key: 'stored',
        name: 'Guardados',
        catalog: 'NOTICE',
        langKey: 'configuration.cell_phone_app_settings.left_panel.saved',
      },
      {
        id: 0,
        key: '',
        name: '',
        catalog: 'TRUE',
      },
      {
        id: 11,
        key: 'polls',
        name: 'Encuestas',
        catalog: 'POLLS',
        langKey: 'configuration.cell_phone_app_settings.left_panel.surveys',
      },
      {
        id: 10,
        key: 'payments',
        name: 'Pagos',
        catalog: 'PAYMENTS',
        langKey: 'configuration.cell_phone_app_settings.left_panel.payments',
      },
      {
        id: 5,
        key: 'qr',
        name: 'QR',
        catalog: 'QR_PROFILE',
        langKey: 'configuration.cell_phone_app_settings.left_panel.qr',
      },
      {
        id: 6,
        key: 'notifications',
        name: 'Configurar notificaciones',
        catalog: 'NOTIFICATIONS_SETTINGS',
        langKey:
          'configuration.cell_phone_app_settings.left_panel.set_up_notifications',
      },
      {
        id: 7,
        key: 'guide',
        name: 'Activar cita guiada',
        catalog: 'TRUE',
        langKey:
          'configuration.cell_phone_app_settings.left_panel.activate_guided_tour',
      },
      {
        id: 8,
        key: 'settings',
        name: 'Configuración',
        catalog: 'TRUE',
        langKey: 'configuration.cell_phone_app_settings.left_panel.settings',
      },
      {
        id: -1,
        key: '',
        name: '',
        catalog: 'TRUE',
      },
      {
        id: 9,
        key: 'logoff',
        name: 'Cerrar sesión',
        catalog: 'TRUE',
        langKey: 'configuration.cell_phone_app_settings.left_panel.logout',
      },
    ],
    sections: [
      {
        id: 1,
        name: 'PICK_UP',
      },
      {
        id: 2,
        name: 'ROUND_PICK_UP',
      },
      {
        id: 3,
        name: 'THIRD_QR',
      },
      {
        id: 4,
        name: 'NOTICE',
      },
      {
        id: 5,
        name: 'STUDENTS',
      },
      {
        id: 6,
        name: 'ROUNDS',
      },
      {
        id: 7,
        name: 'CARS',
      },
      {
        id: 9,
        name: 'CHOFERS',
      },
      {
        id: 10,
        name: 'QR_PROFILE',
      },
      {
        id: 11,
        name: 'NOTIFICATIONS_SETTINGS',
      },
      // {
      //   id: 12,
      //   name: "PAYMENTS"
      // },
      // {
      //   id: 13,
      //   name: "BILLING"
      // },
      {
        id: 14,
        name: 'POLLS',
      },
      {
        id: 15,
        name: 'CHECKOUT_AUTHORIZATION',
      },
      {
        id: 16,
        name: 'ACTIVATE_ACCESS_QR',
      },
    ],
    isValidCheckoutAuhorizationBtn: false,
  }),
  watch: {
    branch() {
      this.isValidCheckoutAuhorization()
      if (this.branch && this.branch.profiles) {
        this.profile = this.branch.profiles[0]
        this.mobileCatalogs = this.branch.profiles[0].mobileCatalogs
        this.mobileCatalogs.sort(function (a, b) {
          return a.id - b.id
        })
        if (this.mobileCatalogs.length > 0) {
          this.bottomNav = this.mobileCatalogs[0].name
        }
        this.sectionForm.selected = this.profile.mobileCatalogs
      }
    },
    updateFlag() {
      if (this.updateFlag) {
        this.update().then(() =>
          this.updateBranch().then(() => {
            this.isValidCheckoutAuhorization()
          })
        )
      }
    },
  },
  filters: {
    menuFilter(value) {
      switch (value) {
        case 'PICK_UP':
          return 'configuration.cell_phone_app_settings.panel.pick_up'
        case 'NOTICE':
          return 'configuration.cell_phone_app_settings.panel.community'
        case 'THIRD_QR':
          return 'configuration.cell_phone_app_settings.panel.third_parties'
        case 'NOTIFICATION':
          return 'configuration.cell_phone_app_settings.panel.notifications'
        case 'ROUND_PICK_UP':
          return 'configuration.cell_phone_app_settings.panel.carpool_deliveries'
        case 'STUDENTS':
          return 'configuration.cell_phone_app_settings.panel.students'
        case 'ROUNDS':
          return 'configuration.cell_phone_app_settings.panel.carpool'
        case 'CARS':
          return 'configuration.cell_phone_app_settings.panel.vehicle'
        case 'PROFILE':
          return 'configuration.cell_phone_app_settings.panel.profile'
        case 'CHOFERS':
          return 'configuration.cell_phone_app_settings.panel.driver'
        case 'QR_PROFILE':
          return 'configuration.cell_phone_app_settings.panel.qr_code_profile'
        case 'NOTIFICATIONS_SETTINGS':
          return 'configuration.cell_phone_app_settings.panel.notification_settings'
        case 'PAYMENTS':
          return 'configuration.cell_phone_app_settings.panel.payments'
        case 'BILLING':
          return 'configuration.cell_phone_app_settings.panel.billing'
        case 'POLLS':
          return 'configuration.cell_phone_app_settings.panel.surveys'
        case 'PERMISSIONS':
          return 'configuration.cell_phone_app_settings.panel.permits'
        case 'CHECKOUT_AUTHORIZATION':
          return 'configuration.cell_phone_app_settings.panel.authorizations'
        case 'ACTIVATE_ACCESS_QR':
          return 'configuration.cell_phone_app_settings.panel.authorizations'
      }
    },
  },
  mounted() {
    this.isValidCheckoutAuhorization()
    if (this.branch && this.branch.profiles) {
      this.profile = this.branch.profiles[0]
      this.mobileCatalogs = this.branch.profiles[0].mobileCatalogs
      this.mobileCatalogs.sort(function (a, b) {
        return a.id - b.id
      })
      if (this.mobileCatalogs.length > 0) {
        this.bottomNav = this.mobileCatalogs[0].name
      }
      this.sectionForm.selected = this.profile.mobileCatalogs
    }
  },
  methods: {
    dictionary(value) {
      switch (value) {
        case 'PICK_UP':
          return this.$t('configuration.cell_phone_app_settings.panel.pick_up')
        case 'NOTICE':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.community'
          )
        case 'THIRD_QR':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.third_parties'
          )
        case 'NOTIFICATION':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.notifications'
          )
        case 'ROUND_PICK_UP':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.carpool_deliveries'
          )
        case 'STUDENTS':
          return this.$t('configuration.cell_phone_app_settings.panel.students')
        case 'ROUNDS':
          return this.$t('configuration.cell_phone_app_settings.panel.carpool')
        case 'CARS':
          return this.$t('configuration.cell_phone_app_settings.panel.vehicle')
        case 'PROFILE':
          return this.$t('configuration.cell_phone_app_settings.panel.profile')
        case 'CHOFERS':
          return this.$t('configuration.cell_phone_app_settings.panel.driver')
        case 'QR_PROFILE':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.qr_code_profile'
          )
        case 'NOTIFICATIONS_SETTINGS':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.notification_settings'
          )
        case 'PAYMENTS':
          return this.$t('configuration.cell_phone_app_settings.panel.payments')
        case 'BILLING':
          return this.$t('configuration.cell_phone_app_settings.panel.billing')
        case 'POLLS':
          return this.$t('configuration.cell_phone_app_settings.panel.surveys')
        case 'PERMISSIONS':
          return this.$t('configuration.cell_phone_app_settings.panel.permits')
        case 'CHECKOUT_AUTHORIZATION':
          return this.$t(
            'configuration.cell_phone_app_settings.panel.authorizations'
          )
        case 'ACTIVATE_ACCESS_QR':
          return 'Accesos'
      }
    },
    // METHOD SIMILAR LIKE THE ONE IN THE PANEL SCREEN
    // PROBLEM IS ON GLOBAL STATE(getBranch), ONCE THAT IS RESOLVED THIS METHOD IS NO LONGER NECCESSARY
    async updateBranch() {
      await this.$store.dispatch('branch/getBrand').then((response) => {
        const brand = response.data.entity

        for (var branch in brand.branches) {
          if (brand.branches[branch].id == this.getUser.branch.id) {
            const imageStorageDoesExist =
              brand.branches[branch].imageStorage !== undefined

            this.$store.commit('updateBranch', {
              branch: {
                ...brand.branches[branch],
                img: imageStorageDoesExist
                  ? brand.branches[branch].imageStorage.miniObjUrl
                  : null,
              },
            })
          }
        }
      })
    },
    isValidCheckoutAuhorization() {
      if (this.branch.settings === undefined) {
        this.isValidCheckoutAuhorizationBtn = false
        return
      }

      const isValid = this.branch.settings.find(
        (e) => e.name === 'CHECKOUT_AUTHORIZATION'
      )

      if (isValid === undefined) {
        this.isValidCheckoutAuhorizationBtn = false
        return
      }

      this.isValidCheckoutAuhorizationBtn = isValid.value === 'YES'
    },
    updateSections(value) {
      value.sort(function (a, b) {
        return a.id - b.id
      })
      this.mobileCatalogs = value
      this.profile.mobileCatalogs = value
    },
    update() {
      this.$v.sectionForm.$touch()
      if (!this.$v.$invalid) {
        this.working.w = true
        var branch = {
          id: this.branch.id,
          profiles: [
            {
              id: this.profile.id,
              mobileCatalogs: this.sectionForm.selected,
            },
          ],
        }
        var json = JSON.stringify(branch) // aqui tienes la lista de objetos en Json
        var obj = JSON.parse(json)
        return this.$store
          .dispatch('branch/updateBranch', obj)
          .then((response) => {
            this.working.w = false
            this.toast.success = true
            this.$emit('resetUpdate')
          })
          .catch((error) => {
            this.working.w = false
            this.toast.failed = true
            this.$emit('resetUpdate')
            console.log(error)
          })
      }
    },
    isSectionPresent(name = undefined) {
      if (name === undefined) {
        return
      }

      return this.sectionForm.selected.some((e) => e.name === name)
    },
    help(value) {
      switch (value) {
        case 'PICK_UP':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.pick_up_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.pick_up_help'
          )
          break
        case 'NOTICE':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.community_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.community_help'
          )
          break
        case 'THIRD_QR':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.third_parties_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.third_parties_help'
          )
          break
        case 'NOTIFICATION':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.notifications_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.notifications_help'
          )
          break
        case 'ROUND_PICK_UP':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.carpool_deliveries_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.carpool_deliveries_help'
          )
          break
        case 'STUDENTS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.students_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.students_help'
          )
          break
        case 'ROUNDS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.carpool_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.carpool_help'
          )
          break
        case 'CARS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.vehicle_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.vehicle_help'
          )
          break
        case 'PROFILE':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.profile_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.profile_help'
          )
          break
        case 'CHOFERS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.driver_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.driver_help'
          )
          break
        case 'QR_PROFILE':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.qr_code_profile_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.qr_code_profile_help'
          )
          break
        case 'NOTIFICATIONS_SETTINGS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.notification_settings_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.notification_settings_help'
          )
          break
        case 'PAYMENTS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.payments_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.payments_help'
          )
          break
        case 'BILLING':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.billing_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.billing_help'
          )
          break
        case 'POLLS':
          this.modals.title = this.$t(
            'configuration.cell_phone_app_settings.panel.surveys_help_title'
          )
          this.modals.description = this.$t(
            'configuration.cell_phone_app_settings.panel.surveys_help'
          )
          break
      }
      this.modals.help = true
    },
  },
  computed: {
    ...mapGetters(['getBranch', 'getUser']),
    bottomNavigation() {
      this.sectionForm.selected.sort(function (a, b) {
        return a.id - b.id
      })
      const pickUpBtn = this.sectionForm.selected.find(
        (item) => item.name === 'PICK_UP'
      )
      const showPermissionsBtn = this.sectionForm.selected.some(
        (item) =>
          item.name === 'THIRD_QR' || item.name === 'CHECKOUT_AUTHORIZATION'
      )
      const noticeBtn = this.sectionForm.selected.find(
        (item) => item.name === 'NOTICE'
      )

      const permissionsBtn = showPermissionsBtn
        ? { id: 15, name: 'PERMISSIONS' }
        : undefined

      return [pickUpBtn, permissionsBtn, noticeBtn].filter(Boolean)
    },
  },
}
</script>

<style>
.annoucement {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/Annoucement.png');
  -webkit-mask-size: 100% 100%;
}

.events {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/Events.png');
  -webkit-mask-size: 100% 100%;
}
.reports {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/reports.png');
  -webkit-mask-size: 100% 100%;
}
.stored {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/stored.png');
  -webkit-mask-size: 100% 100%;
}
.qr {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/qr.png');
  -webkit-mask-size: 100% 100%;
}
.notifications {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/NOTIFICATION.png');
  -webkit-mask-size: 100% 100%;
}
.guide {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/guide.png');
  -webkit-mask-size: 100% 100%;
}
.logoff {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/logoff.png');
  -webkit-mask-size: 100% 100%;
}
.thirdQR {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/expired.png');
  -webkit-mask-size: 100% 100%;
}
.students {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/students.png');
  -webkit-mask-size: 100% 100%;
}
.rounds {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/rounds.png');
  -webkit-mask-size: 100% 100%;
}
.cars {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/cars.png');
  -webkit-mask-size: 100% 100%;
}
.settings {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/settings.png');
  -webkit-mask-size: 100% 100%;
}
.PICK_UP {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/PICK_UP.png');
  -webkit-mask-size: 100% 100%;
}
.NOTICE {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/NOTICE.png');
  -webkit-mask-size: 100% 100%;
}
.THIRD_QR {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/THIRD_QR.png');
  -webkit-mask-size: 100% 100%;
}
.PERMISSIONS {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/THIRD_QR.png');
  -webkit-mask-size: 100% 100%;
}
.NOTIFICATION {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/NOTIFICATION.png');
  -webkit-mask-size: 100% 100%;
}
.payments {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/payments.png');
  -webkit-mask-size: 100% 100%;
}
.billing {
  width: 30px;
  height: 30px;
  background-color: #ef565c;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/billing.png');
  -webkit-mask-size: 100% 100%;
}
.polls {
  width: 30px;
  height: 30px;
  background-color: #b4b4b4;
  object-fit: scale-down;
  -webkit-mask-image: url('../../../assets/mobil/polls.png');
  -webkit-mask-size: 100% 100%;
}
</style>
